export default __webpack_public_path__ + "static/media/musicartes2.1e3028c8.png";